import { Divider, Grid } from '@material-ui/core';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import SelectFieldCustom from '../ui/SelectFieldCustom';
import { TextFieldCustom } from '../ui/TextFieldCustom';
import { useTranslation } from 'react-i18next';

export const FormEmployments = ({ indexApp }) => {
    const { t } = useTranslation();
    const { control, watch } = useFormContext();
    const { fields } = useFieldArray({
        control,
        name: `applicants[${indexApp}].employments`
    });

    const occupation = t('los:occupation', { returnObjects: true });
    const employeestatus = t('los:employeestatus', { returnObjects: true });

    return (
        <>
            {indexApp === 1 ? (
                <>
                    <br />
                    <br />
                    <Divider variant="middle" />
                    <br />
                    <br />
                </>
            ) : null}
            <div className="mb-8">
                <div className="bg-white h-12 border border-l-4 rounded px-5 border-gray-300">
                    <div className="text-lg font-semibold mb-4 mt-2 text-gray-700">
                        {indexApp === 0 ? t('employerLabels.title') : t('employerLabels.title2')}
                    </div>
                </div>
            </div>
            {fields.map((employment, indexEmp) => {
                const empStatus = watch(`applicants[${indexApp}].employments[${indexEmp}].status`);
                return (
                    <div key={employment.id}>
                        <Grid container spacing={3}>
                            <Grid item md={6} xs={12}>
                                <SelectFieldCustom
                                    name={`applicants[${indexApp}].employments[${indexEmp}].status`}
                                    label={t('employerLabels.status')}
                                    items={employeestatus}
                                    defaultValue={employment.status}
                                />
                            </Grid>
                            {empStatus !== 'U' ? (
                                <>
                                    <Grid item md={6} xs={12}>
                                        <SelectFieldCustom
                                            name={`applicants[${indexApp}].employments[${indexEmp}].occupation`}
                                            label={t('employerLabels.occupation')}
                                            items={occupation}
                                            defaultValue={employment.occupation}
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <TextFieldCustom
                                            name={`applicants[${indexApp}].employments[${indexEmp}].employer`}
                                            label={t('employerLabels.employer')}
                                            defaultValue={employment.employer}
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <TextFieldCustom
                                            name={`applicants[${indexApp}].employments[${indexEmp}].since`}
                                            label={t('employerLabels.since')}
                                            type="date"
                                            InputLabelProps={{ shrink: true }}
                                            defaultValue={employment.since}
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <TextFieldCustom
                                            name={`applicants[${indexApp}].employments[${indexEmp}].earning`}
                                            label={t('employerLabels.earning')}
                                            money="true"
                                            defaultValue={employment.earning}
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <TextFieldCustom
                                            name={`applicants[${indexApp}].employments[${indexEmp}].phone`}
                                            label={t('employerLabels.phone')}
                                            helperText={t('optionalField')}
                                            phone="true"
                                            defaultValue={employment.phone}
                                        />
                                    </Grid>
                                </>
                            ) : null}
                        </Grid>
                    </div>
                );
            })}
        </>
    );
};
